import createReducer from "../lib/createReducer";
import * as types from "../actions/types";

const update_appointment_state = {};
export const DATA_update_appointment = createReducer(update_appointment_state, {
  [types.UPDATE_APPOINTMENT](state, action) {
    let newState = update_appointment_state;
    newState = Object.assign({}, newState, action.value);
    return newState;
  }
});
